<div>   
  <span class="badge badge-dark bg-secondary time-color" *ngIf="hours>0" > 
    {{(hours/10).toString().split('.')[0]}}</span>           
    <span class="badge badge-dark bg-secondary time-color" *ngIf="hours>0" >{{hours%10}}</span>
    <span class="badge badge-dark  w-1 sm-timer" *ngIf="hours>0">:</span>
    <span class="badge badge-dark bg-secondary time-color"> {{(minutes/10).toString().split('.')[0]}}</span>
    <span class="badge badge-dark bg-secondary time-color">{{minutes%10}}</span>
    <span class="badge badge-dark bg-secondary w-1 sm-timer ">:</span>
    <span class="badge badge-dark bg-secondary time-color"> {{(seconds/10).toString().split('.')[0]}}</span>
    <span class="badge badge-dark bg-secondary time-color">{{seconds %10}}</span>
  </div> 